import React, { Component } from "react";
import "../styles/sidebar.css";
import adminImage from "../images/user.png";
import { Link, NavLink } from "react-router-dom";

// redux
import { connect } from "react-redux";

//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faParking, faInfo } from "@fortawesome/free-solid-svg-icons";

class Sidebar extends Component {
  handleLogout = e => {
    e.preventDefault();
    this.props.logoutUser();
  };

  handleClick = () => {
    this.setState({
      backgroundColor: "#e3f2fd"
    });
  };

  render() {
    return (
      <div class="sidebar-sticky">
        <Link className="adminDiv" to="/user">
          <img src={adminImage} alt="" className="adminImage" />
          <div className="adminNameDiv">
            <Link id="adminName">{this.props.user.username}</Link>
            <p>Admin</p>
          </div>
        </Link>
        <ul className="list-unstyled">
          <li className="sidebar-links">
            <NavLink className="nav-links" to="/" exact>
              <FontAwesomeIcon className="icon" icon={faHome} />
              Home
            </NavLink>
          </li>
          <li className="sidebar-links">
            <NavLink className="nav-links" to="/parking" exact>
              <FontAwesomeIcon className="icon" icon={faParking} />
              Parking Status
            </NavLink>
          </li>
          <li className="sidebar-links">
            <NavLink className="nav-links" to="/parking-logs" exact>
              <FontAwesomeIcon className="aboutIcon" icon={faInfo} />
              Parking Logs
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(Sidebar);
